import React from 'react';
import classnames from 'classnames';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { RichText } from 'src/components/RichText/RichText';
import { iconsSmallWidth } from 'src/components/ProductDetail/utils/iconsSmallWidth';
import { getUrl } from 'src/components/ProductDetail/utils/getUrl';
import { ProductPrice } from 'src/types/global-types';
import { ProductMainPrice } from 'src/components/BundleProduct/ProductMainPrice';

import classes from './MixAndMatchBundleHeader.scss';

type Props = {
    title: string;
    prices: ProductPrice;
    imgSrc: string;
    shortDescription: { html: string };
    brandBadge?: string;
};

export const MixAndMatchBundleHeader: React.FC<Props> = ({ title, prices, imgSrc, shortDescription, brandBadge }) => {
    let brandImage = null;
    try {
        brandImage = brandBadge ? require(`../../static/img-brands/Logos/${getUrl(brandBadge)}`) : null;
    } catch (err) {
        brandImage = null;
    }

    const titleAndPriceContent = () => (
        <div className={classes.titleAndPriceContainer}>
            <h2 className={classes.bundleTitle}>{title}</h2>
            <div className={classes.priceContainer}>
                <div className={classes.regularPrice}>
                    <ProductMainPrice
                        price={{
                            price: prices.final_price,
                            price_incl: prices.final_price_incl,
                        }}
                    />
                </div>
                {prices.final_price !== prices.regular_price && (
                    <div className={classes.formerPrice}>
                        <ProductMainPrice
                            price={{
                                price: prices.regular_price,
                                price_incl: prices.regular_price_incl,
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );

    return (
        <div className={classes.container}>
            <Breadcrumbs category="Bundles" categoryUrl="deals" subcategory={title} isBundleBreadcrumbs />
            <div className={classes.header}>
                {titleAndPriceContent()}
                {brandBadge && brandImage && (
                    <a
                        className={classnames(classes.logoLink, {
                            [classes.smallLogoLink]: iconsSmallWidth.includes(brandBadge.toLocaleLowerCase()),
                        })}
                        href={`/brands/${brandBadge}`}
                        style={{ backgroundImage: `url(${brandImage})` }}
                    />
                )}
            </div>
            <div className={classes.infoContainer}>
                <div className={classes.copyContainer}>
                    <div className={classes.shortDescriptionContainer}>
                        <RichText content={shortDescription.html} />
                    </div>
                </div>
                {titleAndPriceContent()}
                <div className={classes.logoAndImgContainer}>
                    <div className={classes.image}>
                        <img src={imgSrc} alt={title} />
                    </div>
                </div>
            </div>
        </div>
    );
};
